/**
 * Log a warning message to the console with bootstrap-vue formatting sugar.
 * @param {string} message
 */
/* istanbul ignore next */
function warn(message) {
  console.warn("[Bootstrap-Vue warn]: " + message);
}

export default warn;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/warn.js
// module id = 64
// module chunks = 0